import script from "./RichTextField.vue?vue&type=script&lang=ts&setup=true"
export * from "./RichTextField.vue?vue&type=script&lang=ts&setup=true"

import "./RichTextField.vue?vue&type=style&index=0&id=21e654ba&lang=css"

const __exports__ = script;

export default __exports__